export default [
  {
    name: 'HOME',
    link: '/',
    icon: require('../../assets/image/ic_home.svg'),
    component: require('../Home').default
  },
  {
    name: 'PUSH NOTIFICATION',
    link: '/notification',
    icon: require('../../assets/image/ic_push-notification.svg'),
    component: require('../Notification').default
  },
  // {
  //   groupName: 'PUSH NOTIFICATION',
  //   icon: require('../../assets/image/ic_push-notification.svg'),
  //   routes: [
  //     {
  //       name: 'NOTIFICATION',
  //       link: '/notification',
  //       icon: require('../../assets/image/ic_push-notification.svg'),
  //       component: require('../Notification').default
  //     },
  //     {
  //       name: 'VIP NOTIFICATION',
  //       link: '/vipnotification',
  //       icon: require('../../assets/image/ic_push-notification.svg'),
  //       component: require('../NotificationVIP').default
  //     },
  //     {
  //       name: 'SEGMENTED PUSH NOTIFICATION',
  //       link: '/segmentedPushNotification',
  //       icon: require('../../assets/image/ic_push-notification.svg'),
  //       component: require('../SegmentedPush').default
  //     }
  //   ]
  // },
  {
    name: "PENDING NOTIFICATION",
    link: "/pending-notification",
    icon: require('../../assets/image/ic_history_nav.svg'),
    component: require('../PendingNotification').default
  },
  {
    name: 'SCHEDULED NOTIFICATION',
    link: '/scheduledNotification',
    icon: require('../../assets/image/ic_history_nav.svg'),
    component: require('../ScheduledNotification').default
  }, {
    name: 'NOTIFICATION HISTORY',
    link: '/notificationHistory',
    icon: require('../../assets/image/ic_history_nav.svg'),
    component: require('../NotificationHistory').default
  }, {
    groupName: 'MERCHANT',
    icon: "",
    routes: [
      {
        name: 'REDEMPTION',
        link: '/redemption',
        icon: require('../../assets/image/ic_messages.svg'),
        component: require('../Redemption').default
      }, {
        name: 'REDEMPTION SUMMARY',
        link: '/redemptionsummary',
        icon: require('../../assets/image/ic_messages.svg'),
        component: require('../RedemptionSummary').default
      }, {
        name: 'GENERATE PROMOCODE',
        link: '/generatePromocode',
        icon: require('../../assets/image/ic_messages.svg'),
        component: require('../GeneratePromocode').default
      }
    ]
  }, {
    name: 'SCREEN',
    link: '/screen',
    icon: "",
    component: require('../Screen').default
  }, {
    exact: false,
    name: 'SCREEN LOGS',
    link: '/screenLogs',
    icon: "",
    component: require('../Report').default
    // component: require('../ScreenLogs').default
  }, {
    name: 'VERSION CHECKER',
    link: '/versionChecker',
    icon: "",
    component: require('../VersionChecker').default
  }, {
    name: "CAMPAIGN CATEGORY",
    link: "/campaign-category",
    icon: "",
    component: require('../CampaignCategory').default
  },{
    name: 'EVOUCHER',
    link: '/evoucher',
    icon: "",
    component: require('../EVoucher').default
  }, {
    name: 'EVOUCHER CARD TYPE',
    link: '/evoucher-card-type',
    icon: "",
    component: require('../EVoucherCardType').default
  }, {
    name: 'EVOUCHER PROMO CATEGORY',
    link: '/evoucher-promo-category',
    icon: "",
    component: require('../EVoucherPromoCategory').default
  }, {
    name: "EVSCANNER",
    link: "/evscanner",
    icon: "",
    component: require("../EVScanner").default
  }, {
    name: "MEMBER EV CHECKER",
    link: "/member_ev_checker",
    icon: "",
    component: require("../MemberEVChecker").default
  }, {
    name: "EVOUCHER REPORT",
    link: "/evoucher_report",
    icon: "",
    component: require("../EVoucherReport").default
  }, {
    name: "CALYPSO VOUCHER",
    link: "/calypso_voucher",
    icon: "",
    component: require("../PhoenixVoucher").default
  }, {
    name: "MOBILE POS",
    link: "/mobile_pos",
    icon: "",
    component: require("../MobilePOSScanLog").default
  }, {
    name: "APP BLOCK MESSAGE",
    link: "/app_block_message",
    icon: "",
    component: require("../CustomBlockMessage").default
  }, {
    name: "APP MENU",
    link: "/app_menu",
    icon: "",
    component: require("../AppMenu").default
  }, {
    name: "APP THUMB",
    link: "/app_thumb",
    icon: "",
    component: require("../AppThumb").default
  }, {
    name: "TIER BLOCK MESSAGE",
    link: "/tier_block_message",
    icon: "",
    component: require("../TierBlockMessage").default
  }, {
    name: "MKIOSK BANNER",
    link: "/mkiosk_banner",
    icon: "",
    component: require("../MkioskBanner").default
  }, {
    name: "LIFESTYLE BANNER",
    link: "/lifestyle_banner",
    icon: "",
    component: require("../LifestyleBanner").default
  }, {
    name: "POINTS BANNER",
    link: "/points_banner",
    icon: "",
    component: require("../PointsBanner").default
  }, {
    name: "EASYPROMOS CUSTOM URL",
    link: "/easypromos_customurl",
    icon: "",
    component: require("../EasyPromosCustomURL").default
  }, {
    name: "BEACON",
    link: "/beacon",
    icon: "",
    component: require("../Beacon").default
  }, {
    name: "CARD IMAGES",
    link: "/card_images",
    icon: "",
    component: require("../CardImages").default
  }, {
    name: "KUMULOS",
    link: "/kumulos",
    icon: "",
    component: require("../Kumulos").default
  }, {
    groupName: 'LOGS',
    icon: "",
    routes: [
      {
        name: "CONTACT UPDATE LOG",
        link: "/contact_update_log",
        icon: "",
        component: require("../ContactUpdateLog").default
      }, {
        name: "UPDATE POINTS LOG",
        link: "/update-points-log",
        icon: "",
        component: require("../EVoucherUpdateLogs").default
      },
      {
        name: "API LOG",
        link: "/api_log",
        icon: "",
        component: require("../Logs/APILogs").default
      },
      {
        name: "ERROR LOG",
        link: "/error_log",
        icon: "",
        component: require("../Logs/ErrorLog").default
      },
      {
        name: "MEMBER DETAIL LOG",
        link: "/member_detail_log",
        icon: "",
        component: require("../Logs/MemberDetailLog").default
      },
      {
        name: "PHOENIX API LOG",
        link: "/phoenix_api_log",
        icon: "",
        component: require("../Logs/RWMApiLog").default
      },
      {
        name: "EVOUCHER ERROR LOG",
        link: "/evoucher_error_log",
        icon: "",
        component: require("../Logs/VoucherErrorLog").default
      },
      {
        name: "POINTS WALLET API LOGS",
        link: "/points-wallet-api-logs",
        icon: "",
        component: require("../Logs/PointsWalletAPILogs").default
      },
      {
        name: "E-WALLET API LOGS",
        link: "/e-wallet-api-logs",
        icon: "",
        component: require("../Logs/EWalletAPILogs").default
      },
    ]
  }, {
    name: "E-WALLET",
    link: "/ewallet",
    icon: "",
    component: require("../EWallet").default
  }, {
    name: 'USER SETUP',
    link: '/usersetup',
    icon: "",
    component: require('../UserSetup').default
  }, {
    name: 'APP CONFIG',
    link: '/appconfig',
    icon: "",
    component: require('../AppConfig').default
  }, {
    name: 'MOBILE APP CONFIG',
    link: '/mobile-app-config',
    icon: "",
    component: require('../MobileAppConfig').default
  }, {
    name: 'SIGN UP CONFIG',
    link: '/signup_config',
    icon: "",
    component: require('../SignUpConfig').default
  }, {
    name: 'POINTS WALLET',
    link: '/points-wallet',
    icon: "",
    component: require('../PointsWallet').default
  }, {
    name: 'ACCESS RIGHT',
    link: '/accessright',
    icon: "",
    component: require('../AccessRight').default
  }, {
    name: 'AUDIT TRAIL',
    link: '/audittrail',
    icon: "",
    component: require('../AuditTrail').default
  }
];



// WEBPACK FOOTER //
// ./components/Navigation/routeV2.js